
import {spaceship} from 'helpers/sort'
import BaseModel from 'models/BaseModel'

export default class BaseTask extends BaseModel {

  // アクセサ: 業務コード aka レジコードを取得
  get code() {
    return this.task_code
  }

  // アクセサ: 検索用キー値を取得
  get key() {
    return this.constructor.key(this)
  }

  // アクセサ: 表示用文字列
  get label() {
    return this.name
  }

  // アクセサ: 表示用文字列(短縮形)
  get short_label() {
    return this.short_name
  }

  // アクセサ: レジか？
  get isRegister()
  {
    return 1 <= this.type && this.type <= 4
  }

  // 配列処理: 表示並び順でソート
  static sort(task) {
    return Object.values(task).sort((a, b) =>
      spaceship(a.display_order, b.display_order) ||
      spaceship(a.task_code,     b.task_code)
    )
  }

}
